import { CellList } from "../backend/backendapi";
import { CellTree } from "./cell.model";

export function mapTree(data: CellList[]): CellTree[] {
    let tree: CellTree[] = [];
    let levels: CellTree[] = [];

    for (let i = 0; i < data.length; i++) {
        let d = new CellTree();
        d.item = data[i];
        if (data[i].level === 0) {
            tree.push(d);
        } else {
            levels[data[i].level! - 1].children.push(d);
        }
        levels.splice(data[i].level!);
        levels.push(d);
    }

    return tree;
}